import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  emDataService,
  userService,
} from 'app/services';
import {
  alerts,
  actionIcon
} from 'app/components/global';
import processes from '../processes';
import selectTeamMembersDialog from '../dialog.selectDepartmentTeamMembersDialog';
import editProcessDialog from '../processes/dialog.editProcessDialog';
import uniqueDepartmentNameValidator from './validators/department-unique-name.validator.directive';
import controller from './edit-department-dialog.controller';
import template from './edit-department-dialog.html';
import message from './messages/department.name.messages.html';


class dialogService {
  getOptions($event, { department = null, customerId = 0, isIt = false }) {
    return {
      controller,
      controllerAs: 'editDepartmentDialogVM',
      locals: {
        customerId,
        department,
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
      isIt
    };
  }
}

export default angular.module('app.components.advisory.enterpriseModeling.editDepartmentDialog', [
  alerts,
  actionIcon,
  processes,
  ssDialogService,
  loaderService,
  userService,
  emDataService,
  selectTeamMembersDialog,
  editProcessDialog,
])
  .service('editDepartmentDialog', dialogService)
  .directive('emDepartmentUniqueName', uniqueDepartmentNameValidator)
  .run(($templateCache) => {
    $templateCache.put('department.name.messages.html', message);
  })
  .name;

console.log('app.components.advisory.enterpriseModeling.editDepartmentDialog created');
